module.exports = __webpack_public_path__ + "static/media/Headshot3_1728925953313.9772a33e.jpg";